import { Spinner } from "spin.js";
export class DrivuSpinner{

  static drivuMainSpinner = null; 
  static overlay = null;

  static setDrivuSpinner(){  
    console.log('setDrivuSpinner');  
    if(!DrivuSpinner.drivuMainSpinner){
      DrivuSpinner.drivuMainSpinner = new Spinner({  
        lines: 12,
        length: 7,
        width: 9,
        radius: 30,
        color: '#000',
        speed: 1,
        trail: 60,
        shadow: true,
        className: 'spinner', // CSS class (for any overrides)
        disableHardwareAcceleration: false

      });
    }
    return DrivuSpinner.drivuMainSpinner
  }

  static showOverlaySpinner({ targetElement = document.body, useOverlay = false } = {}) {
    let target = targetElement;
    // Create overlay only if requested
    if (!DrivuSpinner.overlay) {
      const overlay = document.createElement('div');
      overlay.id = 'drivu-spinner-overlay';
      Object.assign(overlay.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: '9999',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'wait',

      });
      document.body.appendChild(overlay);
      DrivuSpinner.overlay = overlay;
    }
    target = DrivuSpinner.overlay;
    DrivuSpinner.setDrivuSpinner();
    DrivuSpinner.drivuMainSpinner.spin(target);
  }

  static showLoadingWheel(targetElement){
    var target = targetElement || document.getElementById('sidebar');  
    DrivuSpinner.setDrivuSpinner();
    DrivuSpinner.drivuMainSpinner.spin(target);
  }

  static hideLoadingWheel(){
    // DrivuSpinner.drivuMainSpinner.stop();

    if (DrivuSpinner.drivuMainSpinner) {
      DrivuSpinner.drivuMainSpinner.stop();
    }

    if (DrivuSpinner.overlay) {
      DrivuSpinner.overlay.remove();
      DrivuSpinner.overlay = null;
    }

  }
}